module.exports = __webpack_public_path__ + "static/media/galeryBaseboards4.f6ed1c1d.jpg";